import { doc, getDoc } from 'firebase/firestore';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Logo from '../../assets/logo-dark.png';
import BackButton from '../../components/BackButton/BackButton';
import { db } from '../../lib/firebase';
import Styles from './Access.module.css';

const Access = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const licenseDocRef = doc(db, 'licenses', code.trim());
      const licenseDoc = await getDoc(licenseDocRef);

      if (licenseDoc.exists()) {
        localStorage.setItem('school_code', code.trim());
        navigate('/classroom');
      } else {
        setError('Invalid code. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
      console.error(err);
    }
  };

  return (
    <div>
      <BackButton destination={'home'} />
      <div className={Styles.centerContainer}>
        <img src={Logo} alt="Logo" className={Styles.logo} />
        <form className={Styles.form} onSubmit={handleSubmit}>
          <input
            className={Styles.input}
            type="text"
            placeholder="Enter School Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
          <button className={Styles.button} type="submit">
            Enter
          </button>
        </form>
        <p className={Styles.error}>{error}</p>
        <p className={Styles.info} onClick={() => navigate('/licensing')}>
          What's a school code?
        </p>
      </div>
      <footer>
        <div className={Styles.footerLinks}>
          <a href="/privacy">Privacy Policy</a>
          <a href="/licensing">Licensing</a>
        </div>
        <p style={{ color: '#6b6b6b', fontSize: '14px' }}>
          © 2026 Brassflows. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Access;
